import React from "react";

export function passwordScore(pw) {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  return Math.min(score, 4);
}

const LABELS = ["Too weak", "Weak", "Fair", "Good", "Strong"];
const BAR_COLORS = ["bg-red-500", "bg-orange-500", "bg-amber-400", "bg-emerald-400", "bg-emerald-500"];
const LABEL_COLORS = ["text-red-300", "text-orange-300", "text-amber-300", "text-emerald-300", "text-emerald-300"];

/** Live strength meter — render under any "choose a new password" field. */
export default function PasswordStrength({ password, testid }) {
  if (!password) return null;
  const score = passwordScore(password);
  return (
    <div className="mt-2" data-testid={testid}>
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`h-1 flex-1 rounded-full transition-colors ${i < score ? BAR_COLORS[score] : "bg-white/10"}`} />
        ))}
      </div>
      <div className={`mt-1 text-[10px] ${LABEL_COLORS[score]}`}>{LABELS[score]}</div>
    </div>
  );
}
